<template>
  <div>
    <div class="form-group">
        <label class="col-sm-2 control-label">姓名</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" placeholder="姓名" v-model="user.profile.name" disabled>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">手机</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" placeholder="手机" v-model="user.profile.phone" disabled>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">地址</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" placeholder="地址" v-model="user.profile.address" disabled>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">性别</label>
        <div class="col-sm-10">
          <select class="form-control" v-model="user.profile.sex" disabled>
            <option value="女">女</option>
            <option value="男">男</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">卡号</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" placeholder="卡号" v-model="user.profile.vipID" disabled>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">余额</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" placeholder="余额" v-model.number="user.profile.balance" disabled>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">现金</label>
        <div class="col-sm-10">
          <input type="number" class="form-control" name="" id="" v-model.number="fee.fromCash" :disabled="mode==='view'">
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">支付宝</label>
        <div class="col-sm-10">
          <input type="number" class="form-control" name="" id="" v-model.number="fee.fromAlipay" :disabled="mode==='view'">
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">微信</label>
        <div class="col-sm-10">
          <input type="number" class="form-control" name="" id="" v-model.number="fee.fromWechat" :disabled="mode==='view'">
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label">赠送</label>
        <div class="col-sm-10">
          <input type="number" class="form-control" name="" id="" v-model.number="fee.giftAccount" :disabled="mode==='view'">
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: ['user', 'fee', 'mode'],
  created() {
    console.log(this.mode === 'view')
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/forms/Recharge.vue